import {createContext, useContext, useEffect, useState} from "react";
import useSWR from "swr";
import {fetchData} from "../../../lib/dashboard/data";
import {sendData} from "../../../lib/dashboard/actions";

const HistoryContext = createContext();

const HistoryProvider = ({children}) => {

    const [selectedAssetName, setSelectedAssetName] = useState(null);
    const [symbols, setSymbols] = useState([]);
    const [selectedSymbol, setSelectedSymbol] = useState(null);
    const [tableAndChartData, setTableAndChartData] = useState({
        data: [],
        isLoading: false,
        isValidating: false,
    });
    const [isLoading, setIsLoading] = useState({
        symbol: false,
    });

    //GET ASSETS
    const assets = useSWR(
        "/option/option-asset-names",
        fetchData,
        {revalidateOnFocus: false,},
    )

    //GET SYMBOLS
    const getSymbols = async () => {
        setIsLoading((prev) => ({...prev, symbol: true}))
        const data = await sendData({asset_name: selectedAssetName}, "/option/asset-symbols")
        setSymbols(data.data);
        setIsLoading((prev) => ({...prev, symbol: false}))
    }
    useEffect(() => {
        if (selectedAssetName) {
            getSymbols()
            setSelectedSymbol(null)
            setTableAndChartData([])
        }
    }, [selectedAssetName])

    //GET TABLE AND CHART DATA
    const getTableAndChartData = async () => {
        setTableAndChartData((prev) => ({...prev, isValidating: true, isLoading: true}))
        const data = await sendData({symbol: selectedSymbol}, "/option/symbol-history");
        setTableAndChartData((prev) => ({...prev, data: data?.data}))
        setTableAndChartData((prev) => ({...prev, isValidating: false, isLoading: false}))
    }
    useEffect(() => {
        if (selectedSymbol) {
            getTableAndChartData()
        }
    }, [selectedSymbol])

    return (
        <HistoryContext.Provider value={{
            assets,
            selectedAssetName,
            setSelectedAssetName,
            symbols,
            selectedSymbol,
            setSelectedSymbol,
            tableAndChartData,
            isLoading,
        }}
        >
            {children}
        </HistoryContext.Provider>
    );
};

export default HistoryProvider;

export function useHistoryContext() {
    return useContext(HistoryContext);
}